import { ref } from 'vue'
import { defineRouter } from '#q-app/wrappers'
import { createMemoryHistory, createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import { anonymousRoutes } from 'src/router/anonymous-routes.js'
import { isProfessional } from 'src/services/session.js'
import { onShowLastUnreadChangelogDialog } from 'src/modules/changelogs/helpers/changelogs.js'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export const routerIsReady = ref(false)

export function setRouterAsReady() {
  routerIsReady.value = true
}

export default defineRouter(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const router = createRouter({
    scrollBehavior: () => ({
      left: 0,
      top: 0
    }),
    routes: anonymousRoutes,
    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
  })

  router.beforeEach((to, from, next) => {
    // Handle route not found. Cannot use "/:pathMatch(.*)*" in routes list because of the order of the routes.
    if (routerIsReady.value) {
      next()
    } else {
      next(false)
    }
  })

  router.afterEach((to) => {
    const avoidedRoute = [
      'homepage',
      'context-selector'
    ]

    if (!avoidedRoute.includes(to.name) && isProfessional.value) {
      onShowLastUnreadChangelogDialog()
    }
  })

  /**
   * Handle missing chunks after a deployment of new static files that replace previous ones
   * the current user might need and hasn't loaded yet.
   */
  const loadingChunkFailedErrorRegex = /loading .*?chunk .*?failed/i
  router.onError((error, to/*, from */) => {
    if (loadingChunkFailedErrorRegex.test(error.message)) {
      window.location.assign(to.fullPath)
    }
  })

  return router
})
